"use strict";

(function ($) {
  $.fn.changePasswordMail = function () {
    var that = $(this);
    that.on('click', function () {
      var action = $(this).data('action'),
          target = $(this).data('target');
      var urlApi = '/api/v1/reset-email-or-password/?action=' + action;
      var dataSend = {
        "action": action,
        "email": $(this).data('mail')
      };
      $.ajax({
        url: urlApi,
        data: JSON.stringify(dataSend),
        contentType: 'application/json',
        method: 'POST',
        success: function success(response) {
          console.log(response);
          $(target).removeClass('is-open');

          if (action == 'reset_email') {
            new Alert().mail();
          }

          if (action == 'reset_password') {
            new Alert().mailPasswd();
          }
        },
        error: function error(_error) {
          console.log(_error);
        }
      });
    });
  };
})(jQuery);

$(function () {
  if ($('.js-reset-passwd-mail').length) {
    $('.js-reset-passwd-mail').changePasswordMail();
  }
});